import React from 'react';
import PropTypes from 'prop-types';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { BaseCrud, FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import {
  TextField,
  IntegerField,
  LookupField,
  CheckboxField,
  SelectField
} from 'react/components/fields';

function PaymentMethodCrud(props) {
  const { id, isGrid, askPaymentDocumentValue, useExternalAppsValue } = props;
  const shouldDisableFieldsWithIdentifyProperty = id && !isGrid;

  const handleHintMessageToAskPaymentDocumentField = (askPaymentDocumentValue) => {
    if (askPaymentDocumentValue === '1') {
      return 'PaymentMethod.field.askForPaymentDocument.document.hint';
    }
    if (askPaymentDocumentValue === '2') {
      return 'PaymentMethod.field.askForPaymentDocument.check.hint';
    }
    return undefined;
  };

  return (
    <BaseCrud updateMethod="PATCH" tabName="PaymentMethod.title" {...props}>
      <FormSection title="PaymentMethod.section.general.title">
        <FormSectionColumn>
          <TextField
            label="PaymentMethod.field.key"
            name="key"
            required
            disabled={shouldDisableFieldsWithIdentifyProperty}
          />
          <LookupField
            label="PaymentMethod.field.organization"
            name="organization"
            lookupEntity="Organization"
            lookupEntityColumn="description"
            required
            disabled={shouldDisableFieldsWithIdentifyProperty}
          />
          <TextField
            label="PaymentMethod.field.description"
            name="description"
            required
          />
          <CheckboxField
            label="PaymentMethod.field.enabled"
            name="enabled"
          />
        </FormSectionColumn>
        <FormSectionColumn>
          <LookupField
            label="PaymentMethod.field.paymentMethodType"
            name="type"
            lookupEntity="PaymentMethodType"
            lookupEntityColumn="key"
          />
        </FormSectionColumn>
      </FormSection>
      <FormSection title="PaymentMethod.section.options.title" className="paymentMethodSectionOptions">
        <FormSectionColumn>
          <CheckboxField
            label="PaymentMethod.field.allowPendingPayment"
            name="allowPendingPayment"
          />
          <CheckboxField
            label="PaymentMethod.field.allowMultiplePayments"
            name="allowMultiplePayments"
          />
          <CheckboxField
            label="PaymentMethod.field.useExternalApps"
            name="useExternalApps"
            hint="PaymentMethod.field.useExternalApps.hint"
          />
        </FormSectionColumn>
        <FormSectionColumn>
          <SelectField
            label="PaymentMethod.field.additionalPaymentDocument"
            name="askPaymentDocument"
            disabled={useExternalAppsValue}
            hint={handleHintMessageToAskPaymentDocumentField(askPaymentDocumentValue)}
            options={[
              {
                label: 'PaymentMethod.field.additionalPaymentDocument.no',
                value: '0'
              },
              {
                label: 'PaymentMethod.field.additionalPaymentDocument.document',
                value: '1'
              },
              {
                label: 'PaymentMethod.field.additionalPaymentDocument.check',
                value: '2'
              }
            ]}
          />
          <IntegerField
            label="PaymentMethod.field.documentSize"
            name="documentSize"
            min={1}
            disabled={useExternalAppsValue}
            shouldShow={askPaymentDocumentValue !== '0'}
          />
          <TextField
            label="PaymentMethod.field.documentMask"
            name="documentMask"
            hint="PaymentMethod.field.documentMask.hint"
            disabled={useExternalAppsValue}
            shouldShow={askPaymentDocumentValue !== '0'}
          />
        </FormSectionColumn>
      </FormSection>
    </BaseCrud>
  );
}

PaymentMethodCrud.defaultProps = {
  id: null,
  isGrid: false,
  askPaymentDocumentValue: '0',
  useExternalAppsValue: false,
};

PaymentMethodCrud.propTypes = {
  id: PropTypes.string,
  isGrid: PropTypes.bool,
  askPaymentDocumentValue: PropTypes.string,
  useExternalAppsValue: PropTypes.bool,
};

const selector = formValueSelector('PaymentMethod');
export default connect(
  (state) => ({ 
    askPaymentDocumentValue: selector(state, 'askPaymentDocument'),
    useExternalAppsValue: selector(state, 'useExternalApps'),
  })
)(PaymentMethodCrud);
